<template>
  <div class="candidate-info">
    <div class="candidate-info-icon">
      <img src="@/assets/icons/genicon-icons8-light.svg" alt="occupation" />
    </div>
    <span :class="{ truncate: shortVersion }">{{
      candidate.occupation || "-"
    }}</span>
  </div>
</template>

<script>
import constants from "@/constants";

export default {
  name: "Occupation",
  props: {
    candidate: {
      type: Object,
      required: true
    },
    shortVersion: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      referenceKey: constants.CANDIDATE_NOTE_OCCUPATION,
      type: constants.CANDIDATE_NOTE_PROFILE
    };
  }
};
</script>
